import { render } from "./Iframe.vue?vue&type=template&id=075b4532"
import script from "./Iframe.vue?vue&type=script&lang=js"
export * from "./Iframe.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__